// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3quW7","row":"styles_row__jqmmH"};